module.exports = __webpack_public_path__ + "static/media/icon_info.a3c18a3d.svg";